import React, { useEffect } from "react";
import { useSubheader } from "../../_metronic/layout";
import { makeStyles, Paper, Grid, TextField, Button } from "@material-ui/core";
import _ from "lodash";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";

// components
import Config from "../helpers/Config";
import SpmApi from "../helpers/SpmApi";
import { useWSnackbar } from "../../_metronic/layout/_core/WSnackbar";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    minWidth: 200,
  },
  paper: {
    width: "100%",
    minHeight: 700,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
  },
  input: {
    width: "250px",
  },
  alignCenter: {
    display: "flex",
    flexWrap: "no-wrap",
    alignItems: "center",
    padding: "5px 0 !important",
  },
  textField: {
    marginRight: theme.spacing(1),
    width: 200,
  },
  remark: {
    minWidth: "400px",
    minHeight: "150px",
  },
  clickableAlert: {
    marginBottom: theme.spacing(3),
    cursor: "pointer",
  },
  inputColor: {
    border: "1px solid red",
  },
  w300: {
    width: "190px",
  },
}));

export default function ChangePassword(props) {
  const wSnackbar = useWSnackbar();
  const domin = Config.get("API_HOST");
  const { location } = props;
  const history = useHistory();
  const classes = useStyles();
  const suhbeader = useSubheader();
  suhbeader.setTitle("修改密碼");
  const [hasntToken, setHasntToken] = React.useState("");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addSchema = Yup.object().shape({
    password: Yup.string()
      .required("此為必填欄位")
      .matches("^[A-Za-z0-9]+$", "必須輸入英文或數字")
      .required("此為必填欄位"),
    new_password: Yup.string()
      .matches(`^[A-Za-z0-9]+$`, "請輸入英文或數字")
      .required("此為必填欄位"),
  });

  // 新增貨運公司
  const formik = useFormik({
    initialValues: {
      password: "",
      new_password: "",
    },
    validationSchema: addSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
        console.log(values)
      SpmApi.post(`${domin}/vendor/password`, {}, values)
        .then((response) => {
          console.log(response);
          wSnackbar.show({ message: _.get(response, "msg") });
        })
        .catch((error) => {
          console.log("err = ", error.response);
          if (_.get(error, "response.data.code") === "403") {
            setHasntToken(_.get(error, "response.data.msg"));
          } else {
            wSnackbar.show({ message: _.get(error, "msg") });
          }
        });
    },
  });

  return (
    <>
      {hasntToken ? (
        <></>
      ) : (
        <Paper className={classes.paper}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} className="d-flex align-items-center">
                <TextField
                  size="small"
                  name="password"
                  label="原始密碼"
                  margin="dense"
                  variant="outlined"
                  placeholder="原始密碼"
                  value={formik.values.password}
                  error={
                    formik.touched.password && _.has(formik, "errors.password")
                  }
                  helperText={formik.touched.password && formik.errors.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item xs={12} className="d-flex align-items-center">
                <TextField
                  size="small"
                  name="new_password"
                  label="新密碼"
                  margin="dense"
                  variant="outlined"
                  placeholder="新密碼"
                  value={formik.values.new_password}
                  error={
                    formik.touched.new_password &&
                    _.has(formik, "errors.new_password")
                  }
                  helperText={
                    formik.touched.new_password && formik.errors.new_password
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item xs={12} className="d-flex align-items-center">
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  type="submit"
                  disableElevation
                >
                  確定
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      )}
    </>
  );
}
